import React, { useEffect } from "react";
import { useDencrypt } from "use-dencrypt-effect";

const decryptOptions = {
    chars: [
        "-",
        ".",
        "/",
        "*",
        "!",
        "?",
        "#",
        "%",
        "&",
        "@",
        "$",
        "€",
        "(",
        ")",
        "[",
        "]",
        "{",
        "}",
        "<",
        ">",
        "~",
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
    ],
    interval: 50,
};

export const Decrypt = (props) => {
    const { result, dencrypt } = useDencrypt(decryptOptions);
    const texts = props.texts;

    useEffect(() => {
        let i = 0;

        const updateText = () => {
            dencrypt(texts[i]);

            i = i === texts.length - 1 ? 0 : i + 1;

            setTimeout(updateText, 3000);
        };

        const action = setTimeout(updateText, 0);

        return () => clearTimeout(action);
    }, [dencrypt, texts]);

    return (
        <p>
            {"a "}
            {result}
        </p>
    );
};

export const DecryptOnce = (props) => {
    const { result, dencrypt } = useDencrypt(decryptOptions);

    React.useEffect(() => {
        const updateText = () => {
            dencrypt(props.text || "");
        };

        const action = setTimeout(updateText, 0);

        return () => clearTimeout(action);
    // }, [dencrypt, props.name, props.text]);
    }, [dencrypt, props.text]);


    return (
        <p>
            {result}
            {" "}
        </p>
    );
};